'use client'

import { ReactNode } from 'react'
import { useCallback, useEffect, useState } from 'react'
import { cn, debounce } from '../../utils'

/**
 *
 * To use with at least a forced white background (invert)
 */
export function ScrollSpy({ children }: { children?: ReactNode }) {
	const getAnchors = useCallback(
		() =>
			(
				Array.from(
					document.querySelectorAll('[id^="spy_"]'),
				) as HTMLDivElement[]
			).map((el) => ({
				id: el.id
					.replaceAll(' ', '_')
					.replaceAll('&amp;', '')
					.replaceAll('&', '')
					.replaceAll("'", ''),
				label: el.id
					.replace('spy_', '')
					.replaceAll('_', ' ')
					.replaceAll('&amp;', '')
					.replaceAll('&', '')
					.replaceAll("'", ''),
				offset: el.offsetTop,
			})),
		[],
	)

	const [sections, setSections] = useState<
		{ id: string; offset: number; label: string }[]
	>([])
	const [_, setScrollPosition] = useState(0)

	useEffect(() => {
		if (!sections.length) {
			const anchors = getAnchors()

			setSections(anchors)

			window.onscroll = debounce(() => scrollHandler(anchors), 200)
		}
	}, [])

	function scrollHandler(anchors: { id: string; offset: number }[]) {
		const { scrollTop, clientHeight } = document.documentElement
		setScrollPosition(scrollTop)
		anchors.forEach((anchor) => {
			if (scrollTop >= anchor.offset - 200) {
				document
					.querySelector('.desktop .spy-active')
					?.classList.remove('spy-active')
				document
					.querySelector('.mobile .spy-active')
					?.classList.remove('spy-active')

				const elMobile = document.querySelector(`.mobile #anchor_${anchor.id}`)
				elMobile?.classList.add('spy-active')

				const elDesktop = document.querySelector(
					`.desktop #anchor_${anchor.id}`,
				)
				elDesktop?.classList.add('spy-active')

				document.querySelector('.auto-scroll')?.scrollTo({
					left: (anchor.offset * 110) / clientHeight,
					behavior: 'auto',
				})
			}
		})
	}

	function scrollToAnchor(anchor: string) {
		const el: HTMLElement = document.querySelector(`#${anchor}`)
		el?.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
			// inline: 'nearest',
		})
		// window.scrollTo({
		// 	top: el?.offsetTop - 90,
		// 	behavior: 'smooth',
		// })
	}

	function getCursorHeight() {
		if (typeof window === 'undefined') return 1
		const scrollspyActiveElement = document.querySelector(
			'.desktop .spy-active',
		) as HTMLElement | null

		if (scrollspyActiveElement && scrollspyActiveElement.offsetTop > 1)
			return scrollspyActiveElement.offsetTop - 54
		return 1
	}

	return (
		<div className="2xl:relative 2xl:pb-[42rem] z-40">
			{!!sections.length && (
				<>
					<div className="hidden 2xl:block 2xl:sticky 2xl:h-0 2xl:mt-[50px] 2xl:top-[30vh] 2xl:w-fit 2xl:ml-8">
						<div
							className="
				absolute left-[-12px] w-0.5 h-0.5 mt-[60px] rounded-full bg-red-500 transition-all
				before:content-[''] before:absolute before:left-[-0.2rem] before:bottom-[-5px] before:w-2 before:h-2 before:bg-red-500 before:rounded-full"
							style={{
								height: getCursorHeight(),
							}}
						/>
					</div>

					<div className="scroll-spy max-2xl:spy-mobile max-sm:hidden z-50">
						<ul className="desktop pt-[50px]">
							{sections.map((anchor, i) => (
								<li key={anchor.id}>
									<a
										id={`anchor_${anchor.id}`}
										className={cn(
											'text-xs cursor-pointer text-gray-400 hover:text-gray-600',
											{
												'spy-active': i === 0,
											},
										)}
										onClick={() => scrollToAnchor(anchor.id)}
									>
										{anchor.label}
									</a>
								</li>
							))}
						</ul>
					</div>
				</>
			)}
			<div className="2xl:mt-[-50px] 2xl:mb-[-42rem]">{children}</div>
		</div>
	)
}
